import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

import { Navbar } from 'components-core';
import {
  ArticleContent,
  ArticleTitle,
  MainTitle,
  VersionInfo,
  Divisor,
} from './ReferralTerms.styles';
import '@ncl/assets/styles/bootstrap.custom.scss';

const ReferralTerms = () => {
  return (
    <>
      <Navbar hideActions />
      <Container>
        <Row>
          <Col>
            <MainTitle>Regulamento do Programa de Indicação para Tomadores</MainTitle>
            <VersionInfo>
              Versão 1.0 <Divisor>|</Divisor> Última atualização: 25 de Agosto de 2020
            </VersionInfo>

            <ArticleContent>
              A Junto Seguros S.A., pessoa jurídica de direito privado, com sede na Rua Visconde de
              Nácar, 1440, 15º andar, Centro, Curitiba, PR, CEP: 80410-201 (“Junto Seguros”), com
              base no presente Regulamento, institui o Programa de Indicação para Tomadores, com o
              objetivo de recompensar seus clientes pela indicação de novos clientes para a Junto
              Seguros, segundo as regras a seguir estipuladas.
            </ArticleContent>
            <ArticleTitle>Definições:</ArticleTitle>
            <ArticleContent>
              Apólice: é o documento emitido pela Junto Seguros, que formaliza a aceitação do risco
              objeto do contrato de seguro. <br />
              <br />
              Corretor: para os fins deste Programa, pessoa jurídica que pode intermediar a
              contratação de uma apólice de seguros. <br />
              <br />
              Indicado: a pessoa jurídica indicada por um Tomador Cadastrado.
              <br />
              <br />
              Plataforma de Emissão: é a plataforma de emissão direta da Junto Seguros, acessada
              pelo link:{' '}
              <a href="https://digital.juntoseguros.com">https://digital.juntoseguros.com/</a>.
              <br />
              <br />
              Prêmio do seguro: é o valor devido pelo Tomador à seguradora pelo seguro para assunção
              de determinado risco e contratação do Seguro Garantia. <br />
              <br />
              Programa: é o Programa de Indicação para Tomadores, desenvolvido pela Junto Seguros.
              <br />
              <br />
              Segurado: é o credor das obrigações assumidas pelo Tomador e destinatário da garantia
              securitária devida pela seguradora. <br />
              <br />
              Seguro Garantia: é o tipo de seguro que tem por objetivo garantir o fiel cumprimento
              das obrigações assumidas pelo tomador perante o segurado.
              <br />
              <br />
              Taxa: é determinada porcentagem utilizada para cálculo do Seguro Garantia. É definida
              pelo porte e estrutura financeira do tomador. <br />
              <br />
              Tomador: é o devedor da obrigação principal para o Segurado que opta por contratar o
              seguro. <br />
              <br />
              Tomador Cadastrado: é o cliente da Junto Seguros cadastrado na Plataforma de Emissão
              direta da Junto. É o devedor das obrigações assumidas perante o segurado.
            </ArticleContent>
            <ArticleTitle>Do Objetivo do Programa:</ArticleTitle>
            <ArticleContent>
              O objetivo do Programa é (i) recompensar um Tomador Cadastrado pela indicação e
              emissão de uma apólice pela Junto Seguros por um novo cliente indicado pelo Tomador
              Cadastrado e (ii) recompensar esse novo cliente após o seu cadastro na Plataforma de
              Emissão da Junto Seguros. <br />
              <br />
              Cada Tomador Cadastrado que indicar um novo cliente para a Junto ganhará, uma vez
              confirmada a emissão por este novo cliente, R$ 100,00 (cem reais) em créditos, os
              quais poderão ser utilizados pelo Tomador Cadastrado na forma de desconto para a
              emissão de novas apólices dentro do prazo de vigência do Programa, observadas as
              limitações para uso do crédito descritas neste Regulamento. A indicação será através
              da disponibilização ao Indicado de um link único do Tomador Cadastrado. <br />
              <br />O Indicado que se cadastrar na Plataforma de Emissão da Junto Seguros utilizando
              o link do Tomador Cadastrado ganhará R$ 50,00 (cinquenta reais) em créditos, os quais
              poderão ser utilizados para emissões a partir da primeira Apólice, observadas as
              limitações para uso do crédito descritas neste Regulamento.
            </ArticleContent>
            <ArticleTitle>Da Adesão e Cancelamento:</ArticleTitle>
            <ArticleContent>
              Durante o prazo de vigência do Programa, a todo Tomador Cadastrado será
              disponibilizado, dentro da Plataforma de Emissão ou através de e-mail marketing, um
              link que irá redirecioná-lo para a página do Programa. Para ter acesso ao link que
              poderá disponibilizar para seus Indicados, ele deverá dar aceite, mediante opt in, ao
              presente Regulamento. Ali, estarão dispostas as informações gerais do Programa, bem
              como o link para este Regulamento. <br />
              <br />
              Para fazer jus ao bônus, o Indicado deverá cadastrar-se na Plataforma de Emissão
              utilizando o link disponibilizado pelo Tomador Cadastrado e dar aceite, mediante opt
              in, aos termos deste Regulamento. <br />
              <br />O Tomador Cadastrado e o Indicado poderão, a qualquer momento, solicitar sua
              exclusão da participação deste Programa, mediante o envio de e-mail para o endereço{' '}
              <a href="mailto:equipe@juntoseguros.com">equipe@juntoseguros.com</a>.
            </ArticleContent>
            <ArticleTitle>Das Limitações ao Uso dos Créditos:</ArticleTitle>
            <ArticleContent>
              Os créditos recebidos pelo Tomador Cadastrado e pelo Indicado valerão pelo prazo de
              Vigência do Programa. Eles poderão ser utilizados como desconto de até 20% (vinte por
              cento) no valor do Prêmio do Seguro. O Prêmio da Apólice, considerados os descontos,
              não poderá, em nenhuma hipótese, ser menor que o prêmio mínimo praticado pela
              Companhia no momento da emissão, de acordo com o disposto em Nota Técnica Atuarial
              aprovada pela Superintendência de Seguros Privados - SUSEP. <br />
              <br />
              Os créditos somente poderão ser utilizados para emissão via Plataforma de Emissão e
              para uso nas modalidades Licitante e Performance Bond (Executante Construtor,
              Fornecedor ou Prestador de Serviços).
            </ArticleContent>
            <ArticleTitle>Demonstração dos Créditos:</ArticleTitle>
            <ArticleContent>
              Os créditos recebidos como bonificação estarão visíveis no painel da Plataforma de
              Emissão da Junto Seguros, após login no sistema. A informação de créditos disponíveis
              também estará visível no momento da emissão pela Plataforma de Emissão, junto com a
              opção de escolha para uso, ou não, dos créditos em determinada contratação de Apólice.
            </ArticleContent>
            <ArticleTitle>Elegibilidade:</ArticleTitle>
            <ArticleContent>
              Serão elegíveis para participar do Programa (i) os Tomadores Cadastrados e (ii) as
              pessoas jurídicas que atendam, obrigatoriamente, os 3 requisitos abaixo descritos:
              <ol type="a">
                <li>
                  Nunca contrataram uma Apólice com a Junto Seguros, incluindo sua antiga
                  denominação social, qual seja, J. Malucelli Seguradora S.A.;
                </li>
                <li>Não possuam cadastro ativo com Corretor na Junto Seguros; e</li>
                <li>
                  Não tenham se cadastrado previamente na Plataforma de Emissão da Junto Seguros.
                </li>
              </ol>
            </ArticleContent>
            <ArticleTitle>Vigência do Programa:</ArticleTitle>
            <ArticleContent>
              O presente Programa é válido por tempo indeterminado. A Junto Seguros reserva-se o
              direito de interromper ou encerrar, a qualquer momento e por qualquer causa, o
              presente Programa. Em caso de interrupção ou encerramento do Programa, os Tomadores
              Cadastrados e os Indicados que por ventura tenham saldo de crédito serão avisados
              previamente ao encerramento do Programa e terão 30 dias a partir da data de aviso para
              utilizar os créditos em forma de desconto em Apólices, observadas as limitações para
              uso do crédito descritas neste Regulamento.
            </ArticleContent>
            <ArticleTitle>Da Proteção de Dados Pessoais: </ArticleTitle>
            <ArticleContent>
              A Junto Seguros, ao coletar seus dados para a participação no Programa e realização
              das atividades a ele correlatas, se compromete a tratar os dados pessoais envolvidos
              na confecção e necessários para possibilitar sua participação no Programa, única e
              exclusivamente para cumprir com a finalidade a que se destinam e em respeito à toda a
              legislação e normas técnicas aplicáveis sobre segurança da informação e proteção de
              dados, inclusive, mas não se limitando, à Lei Geral de Proteção de Dados (Lei Federal
              nº 13.709/2018), sob pena de incidência das penalidades previstas na legislação
              aplicável.
            </ArticleContent>
            <ArticleTitle>Disposições Gerais:</ArticleTitle>
            <ArticleContent>
              A adesão do Tomador Cadastrado e do Indicado ao Programa implica na aceitação total
              das condições descritas neste Regulamento, que é disponibilizado no endereço:{' '}
              <a href="https://digital.juntoseguros.com/conteudo/termos-programa-de-indicacao">
                https://digital.juntoseguros.com/conteudo/termos-programa-de-indicacao
              </a>
              .<br />
              <br /> O não exercício pela Junto Seguros de quaisquer direitos a ela assegurados não
              constituirá causa de alteração ou novação, nem prejudicará o exercício dos mesmos
              direitos em épocas seguintes ou em situações semelhantes. <br />
              <br />A Junto Seguros poderá, a qualquer momento, alterar as condições do Programa,
              mediante prévia comunicação ao Tomador Cadastrado e Indicado. <br />
              <br />
              Será excluído do Programa o Tomador Cadastrado e o Indicado que tenha prestado
              informações ou declarações falsas à Junto Seguros. <br />
            </ArticleContent>
            <ArticleTitle>Foro:</ArticleTitle>
            <ArticleContent>
              Fica eleito o Foro Central da Comarca de Curitiba, PR, para solução de quaisquer
              questões decorrentes deste Regulamento. <br />
              <br />
              Curitiba, 27 de julho de 2020. <br />
              Junto Seguros S.A. <br />
              <br />
              Em caso de dúvidas, entre em contato com a Junto Seguros. <br />
              SAC: 0800 704 0301 <br />
              SAC para deficientes auditivos: 0800 742 6060 <br />
              E-mail: <a href="mailto:equipe@juntoseguros.com">equipe@juntoseguros.com</a>
              <br />
              Ouvidoria: 0800 643 0301 (
              <a href="mailto:ouvidoria@juntoseguros.com">ouvidoria@juntoseguros.com</a>)
              <br />
              <br />
            </ArticleContent>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ReferralTerms;
